module.exports = __webpack_public_path__ + "static/media/construction-digger-excavate-svgrepo-com.7fd61fba.svg";